export default [
  {
    title: 'مدیریت گمرک',
    icon: 'bx bx-buildings',
    children: [
      {
        title: 'گمرک ها',
        route: { name: 'customs' },
        resource: 'CustomsManager',
        action: 'show',
      },
      {
        title: 'نوع های گمرک',
        route: { name: 'customstype' },
        resource: 'CustomsTypeManager',
        action: 'show',
      },
      {
        title: 'کالاهای گمرکی',
        route: { name: 'customsgood' },
        resource: 'CustomsGoodManager',
        action: 'show',
      },
      {
        title: 'رویه های گمرکی',
        route: { name: 'customsprocedure' },
        resource: 'CustomsProcedureManager',
        action: 'show',
      },
      {
        title: 'کارنه تیر',
        route: { name: 'tircarnet' },
        resource: 'TirCarnetManager',
        action: 'show',
      },
    ],
  },
]
